import Page from '../empreendimentos/lancamentos'
export default Page
